import {
  FETCH_CURRENCIES_REQUEST,
  FETCH_CURRENCIES_SUCCESS,
  FETCH_CURRENCIES_FAILURE,
} from 'actionTypes';
import createReducer from './createReducer';

export const initialState = {
  currenciesItems: {
    all: [],
    money: [],
    crypto: [],
  },
  isFetching: false,
  isRequestFailed: false,
};

export const currencies = createReducer(initialState, {
  [FETCH_CURRENCIES_REQUEST]: state => ({
    ...state,
    isFetching: true,
    isRequestFailed: false,
  }),

  [FETCH_CURRENCIES_SUCCESS]: (state, action) => ({
    ...state,
    currenciesItems: {
      ...state.currenciesItems,
      [action.payload.type]: [
        ...state.currenciesItems[action.payload.type],
        ...action.payload.list,
      ],
    },
    isFetching: false,
  }),

  [FETCH_CURRENCIES_FAILURE]: state => ({
    ...state,
    isFetching: false,
    isRequestFailed: true,
  }),
});

export default currencies;
